define('libs/overlay',['require','TweenLite','TweenLiteCSS'],function(require) {

    var _tween = require('TweenLite'),
        _tween_css = require('TweenLiteCSS');

    var SETTINGS = {
        animationTime: .5,
        overlaySelector: '.overlay'
    };

    var Overlay = function() {
        if (INSTANCE) {
            throw new Error('Overlay is a singleton. Use Overlay.getInstance().');
        }

        // clients
        this.clients = [];

        // try to get overlay from the dom.
        this.node = $(SETTINGS.overlaySelector).first();

        // create the overlay
        if (!this.node.length) {
            this.node = $('<div id="' +
            SETTINGS.overlaySelector.replace(/^\.?#?/, '') +
            '" class="overlay" style="display: none; opacity: 0">');
            $(document.body).append(this.node);
        }
        this.node.on('click', function(e) {
            e.preventDefault();
        }.bind(this));
    };

    Overlay.prototype.show = function(client) {
        if (this.clients.indexOf(client) > -1) {
            return;
        }
        this.clients.push(client);

        _tween.to(this.node[0], SETTINGS.animationTime, {
            opacity: 1,
            display: 'block'
        });
    };

    Overlay.prototype.hide = function(client) {
        var index = this.clients.indexOf(client);
        if (index === -1) {
            return;
        }
        this.clients.splice(index, 1);

        if (this.clients.length > 0) {
            return;
        }

        _tween.to(this.node[0], SETTINGS.animationTime, {
            opacity: 0,
            display: 'none'
        });
    };

    var INSTANCE;
    Overlay.getInstance = function() {
        if (!INSTANCE) {
            INSTANCE = new Overlay();
        }
        return INSTANCE;
    };

    return Overlay;
});

